module.exports = __webpack_public_path__ + "img/gkrytlqh.983673c4.png";